import { isAxiosError } from "axios";
import { ApiResponse } from "muminsmart-utils";

export function buildErrorResponse<T>(
  error: any,
  fallback: string,
  logMessage: string,
  data: T,
): ApiResponse<T> {
  console.error(logMessage, error.response?.data || error);
  return {
    success: false,
    data,
    message: getErrorMessage(error, fallback),
  };
}
export function getErrorMessage(error: unknown, fallback: string) {
  if (isAxiosError(error)) {
    return error.response?.data?.message || fallback;
  }

  if (error instanceof Error) {
    return error.message || fallback;
  }

  return fallback;
}

export function getRtkQueryErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (error && typeof error === "object" && "data" in error) {
    const data = (error as { data: unknown }).data;
    if (
      data &&
      typeof data === "object" &&
      "message" in data &&
      typeof (data as { message: unknown }).message === "string"
    ) {
      return (data as { message: string }).message;
    }
  }

  return getErrorMessage(error, fallback);
}
